/**
 * 会员信息
 */
import React from 'react';

import { Input, Row, Col, Icon, Tooltip, DatePicker, Select, Button } from 'antd';
import moment from 'moment';
import PageLayout from '../../ui/PageLayout';
import http from '../../../axios/http';
import messager from '../../ui/messager';
import OrgSelect from '../../ui/OrgSelect';
import Loading from '../../ui/Loading';
import { global_data } from '../../ui/auth'


class RentAuditIndex extends React.Component {

    columns = [{
        title: '商户名称',
        dataIndex: 'contractName',
        width: '10%',
    }, {
        title: '租金',
        dataIndex: 'totalRentFees',
        width: '10%',
    }, {
        title: '租金收缴状态',
        dataIndex: 'rentStatus',
        width: '10%',
        render: (text, record, index) => {
            let title = '未收费';
            let type = "close";
            if (text === 1) {
                title = '已收费';
                type = "check";
            } else if (text === 2) {
                title = '已审核';
                type = 'check-square';
            }
            return (
                <Tooltip title={title}>
                    <Icon type={type} className="table-operate-icon" />
                </Tooltip>
            )
        }
    }, {
        title: '物业费',
        dataIndex: 'totalPropertyFees',
        width: '10%',
    }, {
        title: '物业费收缴状态',
        dataIndex: 'propertyStatus',
        width: '10%',
        render: (text, record, index) => {
            let title = '未收费';
            let type = "close";
            if (text === 1) {
                title = '已收费';
                type = "check";
            } else if (text === 2) {
                title = '已审核';
                type = 'check-square';
            }
            return (
                <Tooltip title={title}>
                    <Icon type={type} className="table-operate-icon" />
                </Tooltip>
            )
        }
    }, {
        title: '水费',
        dataIndex: 'waterFees',
        width: '10%',
    }, {
        title: '电费',
        dataIndex: 'electricityFees',
        width: '10%',
    }, {
        title: '水电收缴状态',
        dataIndex: 'electritictyStatus',
        width: '10%',
        render: (text, record, index) => {
            let title = '未收费';
            let type = "close";
            if (text === 1) {
                title = '已收费';
                type = "check";
            } else if (text === 2) {
                title = '已审核';
                type = 'check-square';
            }
            return (
                <Tooltip title={title}>
                    <Icon type={type} className="table-operate-icon" />
                </Tooltip>
            )
        }
    }, {
        title: '合计',
        dataIndex: 'totalFees',
        width: '10%',
        // format: { 0: '未收费', 1: '已收费', 2: '已审核' }
    }, {
        title: '操作',
        dataIndex: 'id',
        width: '10%',
        render: (text, record, index) =>
            (<div>
                {
                    global_data.authCode.includes("MARKET_RENT_AUDIT_RENT")&&record.rentStatus === 1 ?
                        <Tooltip title="场租费审核完成">
                            <Icon type="check-circle" theme="filled" className="table-operate-icon"  style={{ color: '#d3981a' }} onClick={this.collectFees.bind(this, text, 1)} />
                        </Tooltip>
                        : ''
                }
                {
                    global_data.authCode.includes("MARKET_RENT_AUDIT_PROPERTY")&&record.propertyStatus === 1 ?
                        <Tooltip title="物业费审核完成">
                            <Icon type="check-circle" theme="filled" className="table-operate-icon"  style={{ color: '#008000' }} onClick={this.collectFees.bind(this, text, 2)} />
                        </Tooltip>
                        : ''
                }
                {
                    global_data.authCode.includes("MARKET_RENT_AUDIT_WATERELE")&&record.electritictyStatus === 1 ?
                        <Tooltip title="水电费审核完成">
                            <Icon type="check-circle" theme="filled" className="table-operate-icon" onClick={this.collectFees.bind(this, text, 0)} />
                        </Tooltip>
                        : ''
                }
            </div>)
    }];

    state = {
        visible: false,
        editData: {},
        loadData: '',
        queryData: {
            startDate: moment().month(moment().month() - 1).startOf('month').format("YYYY-MM"),
        },
        loadingVisible: false,
    };

    //完成收费
    collectFees = (info,type, e) => {
        messager.confirm("是否通过该商户的收费审核？", () => {
            http.post({
                url: "/tenantFees/auditTenantFees",
                data: { id: info, type: type },
                success: (res) => {
                    this.state.loadData(this.state.queryData);
                    messager.notify("操作成功！");
                }
            });
        });
    }

    inputSearch = (value) => {
        let queryData = this.state.queryData;
        queryData.memberName = value;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData)
    }
    queryMonthStart = (date, dateString) => {
        let { queryData } = this.state;
        queryData.startDate = dateString;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }

    selectChange = (value) => {
        let { queryData } = this.state;
        queryData.status = value;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }

    orgSelect = (value) => {
        let queryData = this.state.queryData;
        queryData["orgCode"] = value;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData)
    }

    
    download = () =>{
        this.setState({ loadingVisible: true });
        http.download({
            url: '/tenantFees/downloadTenantFees',
            data: this.state.queryData,
            fileName: "租户收费信息.xlsx",
            success: (res) => {
                this.setState({ loadingVisible: false });
            }
        });
    }

    render() {
        return (
            <div style={{ width: '100%', height: '100%' }}>
                <PageLayout
                    condition={(
                        <Row>
                            <Col span={24}>
                                <Input.Search
                                    placeholder="会员名称"
                                    onSearch={this.inputSearch}
                                    enterButton
                                    style={{ width: 200 }}
                                />
                                <Select onChange={this.selectChange} allowClear={true} style={{ width: "100px", margin: '0 10px' }}>
                                    <Select.Option key={"0"}>未收费</Select.Option>
                                    <Select.Option key={"1"}>已收费</Select.Option>
                                    <Select.Option key={"2"}>已审核</Select.Option>
                                </Select>
                                <DatePicker.MonthPicker onChange={this.queryMonthStart} placeholder="月份"
                                    defaultValue={moment().month(moment().month() - 1).startOf('month')} allowClear={false} />
                                <OrgSelect style={{ width: '150px', marginLeft: '10px' }} 
                                    onChange={this.orgSelect}
                                    allowClear={true}
                                    orgType={2}
                                    treeDefaultExpandAll={true} />
                                <Button type="primary" onClick={this.download} style={{"margin":"0 10px", "float":"right"}}>导出</Button>
                            </Col>
                        </Row>
                    )}
                    initParams={this.state.queryData}
                    rowKey="id" url="/tenantFees/findTenantFeesPage" columns={this.columns}
                    loadData={(func) => { this.setState({ loadData: func }); }}
                />
                <Loading visible={this.state.loadingVisible} message="正在处理中，请稍候..." />
            </div>
        )
    }
}

export default RentAuditIndex;